var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import cookies from 'js-cookie';
import md5 from 'js-md5';
import { message as Toast } from 'antd';
function getQueryString(name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
    var r = window.location.search.substr(1).match(reg);
    if (r !== null) {
        return decodeURIComponent(r[2]);
    }
    return null;
}
export function getDeepLink() {
    if (window.location.href.indexOf('inviteUserCardPage=') !== -1) {
        return decodeURIComponent(window.location.href.split('inviteUserCardPage=')[1]) || '';
    }
    return '';
}
export function getUserData() {
    return {
        teamId: process.env.REACT_APP_TEAM_ID,
        appId: process.env.REACT_APP_NAME_ENG,
    };
}
var BaseService = /** @class */ (function () {
    function BaseService() {
        console.log('this.isFocus', getUserData(), this.isFocus);
    }
    BaseService.prototype.getHeaders = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, {
                        appId: process.env.REACT_APP_WEB_APPID,
                        deviceId: '',
                        platform: 'WEB',
                        focusToken: '',
                        focusTeamID: process.env.REACT_APP_TEAM_ID ||
                            cookies.get('focus-team-id') ||
                            'Q9Y03pDCNTCVokPSkLebQ',
                        secretKey: process.env.REACT_APP_WEB_SECRETKEY,
                    }];
            });
        });
    };
    // eslint-disable-next-line max-params
    BaseService.prototype.fetch = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var api, params, accessToken, env_pre, source, headers, gatewayVersion, ts, nonce, tempString, sign, baseurlParam, baseUrl, res, data_1, _a, gwCode, gwEcho, content, code, data, msg;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        api = options.api, params = options.params, accessToken = options.accessToken, env_pre = options.env_pre, source = options.source;
                        return [4 /*yield*/, this.getHeaders()];
                    case 1:
                        headers = _b.sent();
                        gatewayVersion = 2;
                        ts = Date.now().toString();
                        nonce = Date.now().toString(36);
                        tempString = gatewayVersion + "&" + headers.appId + "&" + headers.secretKey + "&" + api + "&" + ts + "&" + nonce + "&" + headers.platform;
                        sign = md5(tempString);
                        baseurlParam = getQueryString('baseurl');
                        baseUrl = source
                            ? source
                            : env_pre === 'prod'
                                ? 'https://open.jzb.beijing.gov.cn/'
                                : env_pre === 'egov'
                                    ? 'https://open.jzb.beijing.egov.cn/'
                                    : 'https://jzb-open-pre.jdcloud.com/';
                        return [4 /*yield*/, fetch("" + baseUrl + api, {
                                method: 'POST',
                                headers: {
                                    // 'x-gw-version': '2',
                                    // 'x-stage': process.env.REACT_APP_GATEWAY_STAGE || 'PROD',
                                    // 'x-api': api,
                                    // 'x-nonce': nonce,
                                    // 'x-ts': ts,
                                    // 'x-app': headers?.appId,
                                    // 'x-token': accessToken,
                                    // 'x-team-id': headers?.focusTeamID,
                                    // 'x-client': headers?.platform,
                                    // 'x-did': headers?.deviceId,
                                    // 'x-sign-headers': tempString,
                                    // 'x-sign': sign,
                                    'Content-Type': 'application/json',
                                    Authorization: "Bearer " + accessToken,
                                },
                                body: JSON.stringify(__assign({}, params)),
                            }).catch()];
                    case 2:
                        res = _b.sent();
                        if (!(res.status !== 200)) return [3 /*break*/, 5];
                        if (!(res.status === 500)) return [3 /*break*/, 4];
                        return [4 /*yield*/, res.json()];
                    case 3:
                        data_1 = _b.sent();
                        _a = data_1, gwCode = _a.gw_code, gwEcho = _a.gw_echo;
                        if (gwCode) {
                            // Modal.error({
                            //     title: i18next.t('error.title'),
                            //     content: `[${gwCode}]${i18next.t('error.gateway', {
                            //         errMsg: gwEcho,
                            //     })}`,
                            // });
                            Toast.error(gwEcho);
                            throw new Error(gwEcho);
                        }
                        _b.label = 4;
                    case 4:
                        // throw new FError(res.status, res.statusText);
                        // throw new Error('error');
                        // this.isFocus ? message.error('网关异常') : Toast.show('网关异常');
                        Toast.error('error');
                        throw new Error('error');
                    case 5: return [4 /*yield*/, res.json()];
                    case 6:
                        content = _b.sent();
                        code = content.code, data = content.data, msg = content.msg;
                        if (code !== 0) {
                            // const err = new FError(errorCode, errorMsg, `content: ${JSON.stringify(content)}`);
                            // if (!ignoreErrMessageAlert) {
                            //     message.error(err.toString());
                            // }
                            // message.error(errorMsg || '暂无数据');
                            // if (code === 99990002) {
                            //     // Toast.fail('注册超时，请重新登录');
                            //     Toast.error({
                            //         icon: 'loginerror',
                            //         content: msg,
                            //     });
                            //     // const history = useHistory();
                            //     // setTimeout(() => {
                            //     //     const base = window.location.href.split('#/')[0];
                            //     //     window.location.href = base;
                            //     //     window.location.replace(base);
                            //     //     // const historylength=window.history.length
                            //     //     // window.history.go()
                            //     // }, 2000);
                            //     // history.push('/')
                            // }
                            Toast.error(msg);
                            throw new Error(msg);
                        }
                        return [2 /*return*/, data];
                }
            });
        });
    };
    return BaseService;
}());
export default BaseService;
//# sourceMappingURL=BaseService.js.map